import { Fragment } from 'react';
import Card from '../ui/Card';
import Closebutton from '../ui/Closebutton';
import Item from '../ui/Item';
import espersso from '../../img/espersso.jpeg';
import turkish from '../../img/turkish.jpeg';
import latte from '../../img/latte.jpeg';
import coffemilk from '../../img/coffemilk.jpeg';
import nescafe from '../../img/nescafe.jpg';
import capuccino from '../../img/capuccino.jpeg';
import hotchoc from '../../img/hotchoc.jpeg';

const dummy_data = [
    {
        key:'d1',
        name:'Esspersso',
        price:20000,
        icon:espersso,
        description:'Single/Double'

    },
    {
        key:'d3',
        name:'Turkish',
        price: 30000,
        icon:turkish,
        description:'Single/Double'
    },
    {
        key:'d4',
        name:'Latte',
        price:35000,
        icon:latte,
        description:'Sm/Med/Lar'
    },
    {
        key:'d5',
        name:'Cafe Milk',
        price: 30000,
        icon:coffemilk,
        description:'Sm/Med/Lar'
    },
    {
        key:'d6',
        name:'Nescafe',
        price:35000 ,
        icon:nescafe,
        description:'Sm/Med/Lar'
    },
    {
        key:'d7',
        name:'Capuccino',
        price: 35000 ,
        icon:capuccino,
        description:'Sm/Med/Lar'
    },
    {
        key:'d8',
        name:'Hot Chocolate',
        price: 40000 ,
        icon:hotchoc,
        description:'Sm/Med/Lar'
    },

] ;


const Drinks = (props) => {

    const drinksList = dummy_data.map((drink) => (
 
    <Item
      key={drink.id}
      name={drink.name}
      price={drink.price}
      icon={drink.icon}
      description={drink.description}
    />
  ));
   
  return (
<Fragment>
    <Closebutton onClick={props.onClick}/>
<Card>

{drinksList}

   </Card>
   </Fragment>
   )
}


export default Drinks;